import React from 'react';
import ReactDOM from 'react-dom/client';
import TorchApp from './TorchApp';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <TorchApp />
  </React.StrictMode>
);
